"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.canHaveValue = canHaveValue;
exports.isValuedItem = isValuedItem;
exports.isAggregateItem = isAggregateItem;
exports.getValue = getValue;
exports.checkEmptyObj = checkEmptyObj;
exports.checkEmptyArr = checkEmptyArr;
exports.isEmptyForm = isEmptyForm;
exports.valuedFields = valuedFields;
exports.bmValuedField = bmValuedField;
exports.hasbmValuedFieldMixin = hasbmValuedFieldMixin;
exports.bmValuedGroup = bmValuedGroup;
exports.hasbmValuedGroupMixin = hasbmValuedGroupMixin;
exports.bmValuedArray = bmValuedArray;
exports.hasbmValuedArrayMixin = hasbmValuedArrayMixin;
exports.bmValuedArrayMixinSymbol = exports.bmValuedArrayMixinSymbolName = exports.bmValuedGroupMixinSymbol = exports.bmValuedGroupMixinSymbolName = exports.bmValuedFieldMixinSymbol = exports.bmValuedFieldMixinSymbolName = void 0;

var _objectSpread5 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _for = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/symbol/for"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _utils = require("../../utils");

var _itemFactory = require("./items/item-engine/item-factory");

function canHaveValue(item) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$overrideAvailabl = _ref.overrideAvailable,
      overrideAvailable = _ref$overrideAvailabl === void 0 ? false : _ref$overrideAvailabl,
      _ref$overrideDisplaye = _ref.overrideDisplayed,
      overrideDisplayed = _ref$overrideDisplaye === void 0 ? false : _ref$overrideDisplaye,
      _ref$overrideDisabled = _ref.overrideDisabled,
      overrideDisabled = _ref$overrideDisabled === void 0 ? false : _ref$overrideDisabled;

  var valuedType = isValuedItem(item);

  if (valuedType) {
    if ((0, _itemFactory.isAvailable)(item)) {
      if ((0, _itemFactory.isDisplayed)(item)) {
        var typeCanDisable = hasbmValuedFieldMixin(item) && item.type !== 'dynamic-label' || hasbmValuedArrayMixin(item);
        var itemEnabled = !typeCanDisable || !item.disabled;
        if (itemEnabled || overrideDisabled) return true;
      } else if (overrideDisplayed) {
        return true;
      }
    } else if (overrideAvailable) {
      return true;
    }

    return false;
  }

  return false;
}

function isValuedItem(item) {
  return hasbmValuedFieldMixin(item) || isAggregateItem(item);
}

function isAggregateItem(item) {
  return hasbmValuedGroupMixin(item) || hasbmValuedArrayMixin(item);
}

function getValue(item) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (hasbmValuedFieldMixin(item)) {
    return item.value;
  }

  if (hasbmValuedGroupMixin(item)) {
    var _context, _context2;

    var formVal = (0, _reduce.default)(_context = (0, _filter.default)(_context2 = (0, _entries.default)(item.options.items || {})).call(_context2, function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          item = _ref3[1];

      return canHaveValue(item, overrides);
    })).call(_context, function (acc, _ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          name = _ref5[0],
          item = _ref5[1];

      acc[name] = getValue(item, overrides);
      return acc;
    }, {});
    formVal = checkEmptyObj(formVal);
    return formVal;
  }

  if (hasbmValuedArrayMixin(item)) {
    var _context3;

    var varFormItem = item;
    var layout = varFormItem.layout;
    var items = varFormItem.options.items;
    var listVal = (0, _map.default)(_context3 = layout.options.order).call(_context3, function (itemName) {
      var item = items[itemName] || {
        mixins: (0, _defineProperty2.default)({}, bmValuedGroupMixinSymbolName, bmValuedGroupMixinSymbol),
        options: {
          items: {}
        }
      };
      var val = getValue(item, overrides);
      val = checkEmptyObj(val);
      return val;
    });
    return checkEmptyArr(listVal);
  }

  throw new Error('no bm values mixin was implemented, please implement!');
}

function checkEmptyObj(formVal) {
  return !(0, _utils.isDefined)(formVal) || (0, _utils.isEmptyObj)(formVal) ? undefined : formVal;
}

function checkEmptyArr(formArrayVal) {
  var filteredList = (0, _filter.default)(formArrayVal).call(formArrayVal, function (v) {
    return (0, _utils.isDefined)(v);
  });
  return filteredList.length > 0 ? filteredList : undefined;
}

function isEmptyForm(form) {
  return (0, _utils.isEmptyObj)(getValue(form));
}

function valuedFields(form) {
  var available = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var relativeFqn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if ((!available || (0, _itemFactory.isAvailable)(form)) && isValuedItem(form)) {
    var _context4;

    if (hasbmValuedFieldMixin(form)) {
      return [(0, _itemFactory.getRelFqn)(form, relativeFqn)];
    }

    var fields = (0, _reduce.default)(_context4 = (0, _entries.default)(form.options.items)).call(_context4, function (acc, _ref6) {
      var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
          item = _ref7[1];

      return (0, _concat.default)(acc).call(acc, valuedFields(item, available, relativeFqn));
    }, []);

    if (hasbmValuedArrayMixin(form)) {
      var name = (0, _itemFactory.getRelFqn)(form, relativeFqn);
      fields.push(name);
    }

    return fields;
  }

  return [];
}

var bmValuedFieldMixinSymbolName = 'bmValuedFieldMixin';
exports.bmValuedFieldMixinSymbolName = bmValuedFieldMixinSymbolName;
var bmValuedFieldMixinSymbol = (0, _for.default)(bmValuedFieldMixinSymbolName);
exports.bmValuedFieldMixinSymbol = bmValuedFieldMixinSymbol;

function bmValuedField(clazz) {
  var _temp;

  return _temp = /*#__PURE__*/function (_clazz) {
    (0, _inherits2.default)(_temp, _clazz);

    var _super = (0, _createSuper2.default)(_temp);

    function _temp() {
      var _context5;

      var _thisSuper, _this;

      (0, _classCallCheck2.default)(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, (0, _concat.default)(_context5 = [this]).call(_context5, args));
      _this.mixins = (0, _objectSpread5.default)((0, _objectSpread5.default)({}, (0, _get2.default)((_thisSuper = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(_temp.prototype)), "mixins", _thisSuper)), {}, (0, _defineProperty2.default)({}, bmValuedFieldMixinSymbolName, bmValuedFieldMixinSymbol));
      return _this;
    }

    return _temp;
  }(clazz), _temp;
}

function hasbmValuedFieldMixin(item) {
  return item.mixins && item.mixins[bmValuedFieldMixinSymbolName] === bmValuedFieldMixinSymbol;
}

var bmValuedGroupMixinSymbolName = 'bmValuedGroupMixin';
exports.bmValuedGroupMixinSymbolName = bmValuedGroupMixinSymbolName;
var bmValuedGroupMixinSymbol = (0, _for.default)(bmValuedGroupMixinSymbolName);
exports.bmValuedGroupMixinSymbol = bmValuedGroupMixinSymbol;

function bmValuedGroup(clazz) {
  var _temp2;

  return _temp2 = /*#__PURE__*/function (_clazz2) {
    (0, _inherits2.default)(_temp2, _clazz2);

    var _super2 = (0, _createSuper2.default)(_temp2);

    function _temp2() {
      var _context6;

      var _thisSuper2, _this2;

      (0, _classCallCheck2.default)(this, _temp2);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      _this2 = _super2.call.apply(_super2, (0, _concat.default)(_context6 = [this]).call(_context6, args));
      _this2.mixins = (0, _objectSpread5.default)((0, _objectSpread5.default)({}, (0, _get2.default)((_thisSuper2 = (0, _assertThisInitialized2.default)(_this2), (0, _getPrototypeOf2.default)(_temp2.prototype)), "mixins", _thisSuper2)), {}, (0, _defineProperty2.default)({}, bmValuedGroupMixinSymbolName, bmValuedGroupMixinSymbol));
      return _this2;
    }

    return _temp2;
  }(clazz), _temp2;
}

function hasbmValuedGroupMixin(item) {
  return item.mixins && item.mixins[bmValuedGroupMixinSymbolName] === bmValuedGroupMixinSymbol;
}

var bmValuedArrayMixinSymbolName = 'bmValuedArrayMixin';
exports.bmValuedArrayMixinSymbolName = bmValuedArrayMixinSymbolName;
var bmValuedArrayMixinSymbol = (0, _for.default)(bmValuedArrayMixinSymbolName);
exports.bmValuedArrayMixinSymbol = bmValuedArrayMixinSymbol;

function bmValuedArray(clazz) {
  var _temp3;

  return _temp3 = /*#__PURE__*/function (_clazz3) {
    (0, _inherits2.default)(_temp3, _clazz3);

    var _super3 = (0, _createSuper2.default)(_temp3);

    function _temp3() {
      var _context7;

      var _thisSuper3, _this3;

      (0, _classCallCheck2.default)(this, _temp3);

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      _this3 = _super3.call.apply(_super3, (0, _concat.default)(_context7 = [this]).call(_context7, args));
      _this3.mixins = (0, _objectSpread5.default)((0, _objectSpread5.default)({}, (0, _get2.default)((_thisSuper3 = (0, _assertThisInitialized2.default)(_this3), (0, _getPrototypeOf2.default)(_temp3.prototype)), "mixins", _thisSuper3)), {}, (0, _defineProperty2.default)({}, bmValuedArrayMixinSymbolName, bmValuedArrayMixinSymbol));
      return _this3;
    }

    return _temp3;
  }(clazz), _temp3;
}

function hasbmValuedArrayMixin(item) {
  return item.mixins && item.mixins[bmValuedArrayMixinSymbolName] === bmValuedArrayMixinSymbol;
}
